import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output } from "@angular/core";
import { BehaviorSubject } from "rxjs";


@Component({
    selector: "json-forms-node-new",
    templateUrl: "./json-forms-node-new.component.html",
    styleUrls: ["./json-forms-node-new.component.scss"],
    standalone: false
})
export class JsonFormsNodeNewComponent {

  @Input() data: any;
  @Input() path: string[] = [];
  @Output() userChanging:EventEmitter<void> = new EventEmitter<void>();

  getType(value: any): string {
    if (Array.isArray(value)) return 'array';
    if (value !== null && typeof value === 'object') return 'object';
    if (value == null ){return 'string'}
    return typeof value;
  }

  get objectKeys(): string[] {
    return this.data && typeof this.data === 'object' && !Array.isArray(this.data)
      ? Object.keys(this.data)
      : [];
  }

  trackByIndex(index: number): number {
    return index;
  }


  newKey: string = '';

  addObjectKey() {
    if (this.newKey && !this.data.hasOwnProperty(this.newKey)) {
      this.data[this.newKey] = '';
      this.newKey = '';
    }
  }

  addArrayItem(key: string) {
    if (Array.isArray(this.data[key])) {
      this.data[key].push('');
    }
  }

  removeKey(key: string) {
    if (Array.isArray(this.data)) {
      this.data.splice(+key, 1);
    } else {
      delete this.data[key];
    }
  }

  onChangeNumberValue(value,data,key){
    if (value == null ){
      data[key] = 0;
    }else{
      data[key] = value;
    }
    this.userChanging.emit();
  }

  onChangeString(value,data,key){
    data[key] = value;
    this.userChanging.emit();
    
  }
}
